import React, { useCallback } from "react";
import { Marker } from "react-map-gl";
import { Box, styled, Tooltip } from "@material-ui/core";
import { StoreType } from "../../constants";
import StoreCard from "../StoreCard";
import theme from "../../../../theme/material-ui-theme";

const Icon = styled("div")(({}) => ({
  cursor: "pointer",
  color: theme.palette.primary.main
}));

const CustomToolTip = styled(Tooltip)(({}) => ({
  color: theme.palette.primary.main
}));

const CustomMarker = styled(Marker)(
  ({ isSelected }: { isSelected: boolean }) => ({
    zIndex: isSelected ? 1000 : null,
    position: "relative"
  })
);

type Props = {
  store: StoreType;
  isSelected?: boolean;
  isHovered?: boolean;
  onClick?: (store: StoreType) => void;
  disableTooltip?: boolean;
  disableStoreCardPopup?: boolean;
};

const StoreMarker = React.memo(
  ({
    store,
    isSelected,
    onClick,
    disableTooltip,
    disableStoreCardPopup
  }: Props) => {
    const _onClick = useCallback(() => onClick(store), []);

    const svg = (
      <svg
        width="26"
        height="38"
        viewBox="0 0 26 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.16306 19.8816C4.3228 21.8764 12.9934 37 12.9934 37C12.9934 37 12.9967 36.995 13 36.9867C13.005 36.995 13.0067 37 13.0067 37C13.0067 37 21.6755 21.8764 22.8369 19.8816C24.0466 17.802 25 15.5658 25 13.0083C25 6.37643 19.6273 0.999997 13 0.999997C6.37271 0.999998 1 6.37644 1 13.0083C1 15.5658 1.95341 17.8037 3.16306 19.8816Z"
          fill="currentColor"
          stroke={isSelected ? "black" : "#C79600"}
          strokeWidth="1"
        />
      </svg>
    );

    return (
      <CustomMarker
        {...store.coordinates}
        offsetTop={-38}
        offsetLeft={-13}
        isSelected={isSelected}
      >
        <Icon
          onClick={_onClick}
          title={store.title}
          data-testid="store-locator.mapMarker"
          data-selected={isSelected}
          style={{ overflow: "hidden" }}
        >
          {disableTooltip && svg}
          {!disableTooltip && (
            <CustomToolTip
              title={store.title}
              placement="top"
              arrow
              disableFocusListener
              disableTouchListener
              enterDelay={25}
            >
              {svg}
            </CustomToolTip>
          )}

          {!disableStoreCardPopup && isSelected && (
            <Box
              width="350px"
              height="auto"
              bgcolor="common.white"
              position="absolute"
              top="-294px"
              left="-161px"
              color={theme.palette.text.primary}
              borderRadius="10px"
            >
              <div
                style={{
                  display: "inline-block",
                  width: 0,
                  height: 0,
                  borderStyle: "solid",
                  borderWidth: "6px 5px 0 5px",
                  borderColor: "#ffffff transparent transparent transparent",
                  position: "absolute",
                  bottom: "-6px",
                  left: "calc(50% - 6px)"
                }}
              />
              <StoreCard
                // Hacky: Only show first 3 labels on the map, to limit the height of the card
                store={{ ...store, labels: store.labels.slice(0, 3) }}
                isTooltip
              />
            </Box>
          )}
        </Icon>
      </CustomMarker>
    );
  }
);

export default StoreMarker;
